import React from 'react'
import User from '@assets/img/reservation/user.svg'
import SectionHeading from './SectionHeading'
import ReservationBox from './ReservationBox'
import PersonalDataDetails from './PersonalDataDetails'
import { useReservationContext } from './ReservationContext'
import InfoPink from '@assets/img/reservation/info-pink.svg'
import ErrorIcon from '@assets/img/reservation/error-icon.svg'
import classNames from 'classnames'
import Smile from '@assets/img/reservation/smile.svg'

const ParticipantsView = () => {
    const { form, handleChildrenChange, errors, handleAdultChange, formattedToday, formattedMinDate, t } =
        useReservationContext()

    return (
        <>
            <div className="trip-reservation__section">
                <SectionHeading headingText={t('participants-data')} subheaderText={t('enter-participants-data')} />
                {Object.keys(errors).length !== 0 ? (
                    <div className="trip-reservation__error-announcement">
                        <img src={InfoPink} alt="info" />
                        {t('please-fill-form-fields')}
                    </div>
                ) : null}
                <div className="trip-reservation__small-heading">{t('address-data')}</div>
                <PersonalDataDetails />
            </div>
            <div className="trip-reservation__section trip-reservation__section--participants">
                {form.adults.map((person, i) => (
                    <ReservationBox key={`adult-${i}`} headerText={`${t('adult')} ${i + 1}`} icon={User}>
                        <div className="trip-reservation__personal-data">
                            <label className="trip-reservation__label">
                                {t('first-name')}
                                <input
                                    type="text"
                                    placeholder={t('first-name')}
                                    value={person.name}
                                    onChange={(e) => handleAdultChange(i, 'name', e.target.value)}
                                    className={classNames('trip-reservation__input', {
                                        'trip-reservation__input--error': errors.email,
                                    })}
                                />
                                {errors[`adults.${i}.name`] ? (
                                    <>
                                        <div className="trip-reservation__error">{errors[`adults.${i}.name`]}</div>
                                        <img
                                            className="trip-reservation__error-icon"
                                            src={ErrorIcon}
                                            alt=""
                                        />
                                    </>
                                ) : null}
                            </label>
                            <label className="trip-reservation__label">
                                {t('last-name')}
                                <input
                                    type="text"
                                    placeholder={t('enter-last-name')}
                                    value={person.surname}
                                    onChange={(e) => handleAdultChange(i, 'surname', e.target.value)}
                                    className={classNames('trip-reservation__input', {
                                        'trip-reservation__input--error': errors.email,
                                    })}
                                />
                                {errors[`adults.${i}.surname`] ? (
                                    <>
                                        <div className="trip-reservation__error">{errors[`adults.${i}.surname`]}</div>
                                        <img
                                            className="trip-reservation__error-icon"
                                            src={ErrorIcon}
                                            alt=""
                                        />
                                    </>
                                ) : null}
                            </label>
                            <label className="trip-reservation__label">
                                {t('birth-date')}
                                <input
                                    type="date"
                                    placeholder={t('enter-date-birth')}
                                    value={person.birthdate}
                                    onChange={(e) => handleAdultChange(i, 'birthdate', e.target.value)}
                                    className={classNames('trip-reservation__input', {
                                        'trip-reservation__input--error': errors.email,
                                    })}
                                    min="1900-01-01"
                                    max={formattedToday}
                                />
                                {errors[`adults.${i}.birthdate`] ? (
                                    <div className="trip-reservation__error">{errors[`adults.${i}.birthdate`]}</div>
                                ) : null}
                            </label>
                            <label className="trip-reservation__label">
                                {t('gender')}
                                <select
                                    placeholder={t('gender')}
                                    value={person.gender}
                                    onChange={(e) => handleAdultChange(i, 'gender', e.target.value)}
                                    className="trip-reservation__select"
                                >
                                    <option value={'M'}>{t('male')}</option>
                                    <option value={'F'}>{t('female')}</option>
                                </select>
                                {errors[`adults.${i}.gender`] && (
                                    <p className="error">{errors[`adults.${i}.gender`][0]}</p>
                                )}
                            </label>
                        </div>
                    </ReservationBox>
                ))}
                {form.children.map((person, i) => (
                    <ReservationBox key={`child-${i}`} headerText={`Dziecko ${i + 1}`} icon={Smile}>
                        <div className="trip-reservation__personal-data">
                            <label className="trip-reservation__label">
                                {t('first-name')}
                                <input
                                    type="text"
                                    placeholder={t('enter-first-name')}
                                    value={person.name}
                                    onChange={(e) => handleChildrenChange(i, 'name', e.target.value)}
                                    className={classNames('trip-reservation__input', {
                                        'trip-reservation__input--error': errors.email,
                                    })}
                                />
                                {errors[`children.${i}.name`] ? (
                                    <div className="trip-reservation__error">{errors[`children.${i}.name`]}</div>
                                ) : null}
                            </label>
                            <label className="trip-reservation__label">
                                {t('last-name')}
                                <input
                                    type="text"
                                    placeholder={t('enter-last-name')}
                                    value={person.surname}
                                    onChange={(e) => handleChildrenChange(i, 'surname', e.target.value)}
                                    className={classNames('trip-reservation__input', {
                                        'trip-reservation__input--error': errors.email,
                                    })}
                                />
                                {errors[`children.${i}.surname`] ? (
                                    <>
                                        <div className="trip-reservation__error">{errors[`children.${i}.surname`]}</div>
                                        <img
                                            className="trip-reservation__error-icon"
                                            src={ErrorIcon}
                                            alt=""
                                        />
                                    </>
                                ) : null}
                            </label>
                            <label className="trip-reservation__label">
                                {t('birth-date')}
                                <input
                                    type="date"
                                    placeholder="Data urodzenia"
                                    value={person.birthdate}
                                    onChange={(e) => handleChildrenChange(i, 'birthdate', e.target.value)}
                                    className={classNames('trip-reservation__input', {
                                        'trip-reservation__input--error': errors.email,
                                    })}
                                    min={formattedMinDate}
                                    max={formattedToday}
                                />
                                {errors[`children.${i}.birthdate`] ? (
                                    <div className="trip-reservation__error">{errors[`children.${i}.birthdate`]}</div>
                                ) : null}
                            </label>
                            <label className="trip-reservation__label">
                                {t('gender')}
                                <select
                                    type="date"
                                    placeholder={t('gender')}
                                    value={person.gender}
                                    onChange={(e) => handleAdultChange(i, 'gender', e.target.value)}
                                    className="trip-reservation__select"
                                >
                                    <option value={'M'}>{t('male')}</option>
                                    <option value={'F'}>{t('female')}</option>
                                </select>
                                {errors[`children.${i}.gender`] && (
                                    <p className="error">{errors[`children.${i}.gender`][0]}</p>
                                )}
                            </label>
                        </div>
                    </ReservationBox>
                ))}
            </div>
        </>
    )
}

export default ParticipantsView
